// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"0e920cc9","42":"9391e87b","346":"fdc5646c","488":"c0d68af0","680":"42fd97f4","861":"0733d21a"}[chunkId] + ".chunk.css";
};